import { Button } from 'design-system';
import { FileTextIcon } from 'lucide-react';

import type { RelatedCode } from '@/features/factsheet';
import { useIsFactsheetCompact } from '@/features/factsheet/state/useIsFactsheetCompact';
import { cn } from '@/lib/utils';

const RelatedCodeItem = ({
  relatedCode,
  openNewTab
}: {
  relatedCode: RelatedCode;
  openNewTab: (code: string) => void;
}) => {
  const isCompact = useIsFactsheetCompact();
  return (
    <div className='flex items-center pb-1'>
      <Button
        variant='ghost'
        size='icon-sm'
        className='mr-0.5 size-7'
        onClick={() => {
          openNewTab(relatedCode.code);
        }}
      >
        <FileTextIcon className={isCompact ? 'size-3.5' : 'size-4'} />
      </Button>
      <span className={cn('mr-2 font-bold', isCompact && 'text-sm')}>{relatedCode.code}</span>
      <span className={cn(isCompact && 'text-sm')}>{relatedCode.title}</span>
    </div>
  );
};

export default RelatedCodeItem;
